import { useMutation, useQuery } from "@tanstack/react-query";
import { getExchangeRate } from "@api/v1/methods";
import { GetExchangeRateParams } from "@api/v1/model";
import { GET_EXCHANGE_RATE } from "../../cacheKeys";

export const useGetExchangeRate = (
  params: GetExchangeRateParams,
  enabled = true
) =>
  useQuery({
    queryKey: [GET_EXCHANGE_RATE, JSON.stringify(params)],
    queryFn: () => getExchangeRate(params),
    enabled: !!params.from && !!params.to && enabled,
  });

export const useGetExchangeRateOnDemand = () => {
  return useMutation({ mutationFn: getExchangeRate, throwOnError: false });
};
